import React from "react";
// import { Responsive, WidthProvider } from "react-grid-layout";
import CurrentCoverage from "../../widgets/retail/CurrentCoverage";
import TotalOfficeStockBuild from "../../widgets/retail/TotalOfficeStockBuild";
import CurrentVacancy from "../../widgets/retail/CurrentVacancy";
import CurrentPassingRent from "../../widgets/retail/CurrentPassingRent";
import PanIndiaCommercial from "../../widgets/retail/PanIndiaCommercial";
import UpcomingSupply from "../../widgets/retail/UpcomingSupply";
import OfficeDemandSupplyChart from "../../widgets/retail/OfficeDemandSupplyChart";
import RentalsAnalysisChart from "../../widgets/retail/RentalsAnalysisChart";
import MajorRecentLeaseTransactions from "../../widgets/retail/MajorRecentLeaseTransactions";
import UpcomingProjectCompletions from "../../widgets/retail/UpcomingProjectCompletions";
import TopOfficeProjects from "../../widgets/retail/TopOfficeProjects";
import TopOfficeTenants from "../../widgets/retail/TopOfficeTenants";
import TopsectorsOfficeLeasing from "../../widgets/retail/TopsectorsOfficeLeasing";
import TopDevelopersInOfficeDevelopment from "../../widgets/retail/TopDevelopersInOfficeDevelopment";
import MajorRecentSaleTransactions from "../../widgets/retail/MajorRecentSaleTransactions";
import AssetSummary from "../../widgets/retail/AssetSummary";
// import LatestNews from "../../widgets/retail/LatestNews";
import RecentSearches from "../../widgets/retail/RecentSearches";
import SavedFilters from "../../widgets/retail/SavedFilters";
import RecentTransactions from "../../widgets/retail/RecentTransactions";
// import Map from "../../widgets/retail/Map";
// import Map1 from "../../widgets/retail/Map1";

// const ResponsiveGridLayout = WidthProvider(Responsive);

class Dashboard extends React.Component {
  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-9">
            <div className="row">
              <CurrentCoverage />
              <div className="col-lg-4 mb-4">
                <TotalOfficeStockBuild />
              </div>
              <div className="col-lg-4 mb-4">
                <CurrentVacancy />
              </div>
              <div className="col-lg-4 mb-4">
                <CurrentPassingRent />
              </div>
              <PanIndiaCommercial />
              <div className="col-lg-4 mb-4">
                <UpcomingSupply />
              </div>
            </div>
            <div className="row mb-4">
              <OfficeDemandSupplyChart />
              <RentalsAnalysisChart />
            </div>
            <div className="row">
              <MajorRecentLeaseTransactions />
              <UpcomingProjectCompletions />
            </div>
            <div className="row mt-4">
              <TopOfficeProjects />
              <TopOfficeTenants />
            </div>
            <div className="row mt-4">
              <TopsectorsOfficeLeasing />
              <TopDevelopersInOfficeDevelopment />
            </div>
            <div className="row mt-4">
              <MajorRecentSaleTransactions />
            </div>
            <div className="row mt-4">
              <AssetSummary />
              {/* <LatestNews /> */}
            </div>
            <div className="row mt-4"></div>
          </div>
          <div className="col-lg-3 rightSideBar">
            <RecentSearches />
            <SavedFilters />
            <RecentTransactions />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            {/* <Map /> */}
            {/* <Map1 zoom={2} styleProp={{ height: "100vh", width: "100vh" }} />
            <MajorRecentSaleTransactions /> */}
          </div>
        </div>
      </div>
    );
  }
}
export default Dashboard;
